// import { environment } from './../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AvataresService {
  private api = 'http://localhost:3101/api-core/v1';

  constructor(private http: HttpClient) {
    // do nothing
  }

  getAvatares() {
    return this.http.get<any[]>(`${this.api}/avatares`).pipe(
      // Primero filtramos aquellos que tengan un img_avatar definido
      map((avatares) => avatares.filter((avatar) => !!avatar.img_avatar).map((avatar: any) => ({ ...avatar, img_avatar: avatar.img_avatar }))),
    );
  }
}
